import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { Trophy, AlertCircle } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';

interface FinishModalProps {
    onClose: () => void;
    onConfirm: () => void;
    isSaving: boolean;
    globalPercent: number;
}

export const FinishModal: React.FC<FinishModalProps> = ({ onClose, onConfirm, isSaving, globalPercent }) => (
    <ModalWrapper onClose={onClose} borderColor={globalPercent >= 100 ? '#2ecc71' : '#f29b11'}>
        {globalPercent >= 100 ? <Trophy size={48} color="#2ecc71" style={{ margin: '0 auto 20px' }} className="animate-bounce" /> : <AlertCircle size={48} color="#f29b11" style={{ margin: '0 auto 20px' }} />}
        <h2 style={{ ...UI.text.title, fontSize: 20, marginBottom: 10 }}>{globalPercent >= 100 ? 'Activity Accomplished' : 'Finish Early?'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button className="premium-btn-primary" style={{ ...UI.button.primary, backgroundColor: globalPercent >= 100 ? "#2ecc71" : "#fff", color: "#000", borderColor: "transparent" }} onClick={onConfirm} disabled={isSaving}>{isSaving ? 'SYNCING...' : 'FINALIZE & SAVE'}</button>
            <button onClick={onClose} style={{ all: 'unset', color: '#666', fontSize: '11px', fontWeight: '900', textTransform: 'uppercase', cursor: 'pointer', padding: '10px' }}>Wait, I missed something</button>
        </div>
    </ModalWrapper>
);
